/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
import React, { useState } from 'react';
import { IconBannerCategory } from '../../../../components/buttons/IconButtons';
import { CustomTextField } from '../../../../components/CustomTextField';
import CustomModal from '../../../../components/Modal/CustomModal';
import { useTranslation } from 'react-i18next';
import CustomCard from '../../../../components/CustomCard';
import { CreateCategoryAndSubcategory } from '../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { errorMsg } from '../../../../Apis/functions';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { CATEGORY_TYPE } from './../../../../pages/Dashboard/Contractors/EquipmentAndMaterial/Model/Model';
import { CREATE_CATEGORY_MODEL } from '../model';
import HandleChange from '../../../../Helpers/HandleChange';

const CreateCategory = ({ show, onHide, titleModal, inputModal, icon: Icon, type, setModified }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [emptyFields, setEmptyFields] = useState(false);
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [item, setItem] = useState({
        ...CREATE_CATEGORY_MODEL,
    });
 const { handleChange } = HandleChange({ model: item, setModel: setItem });
    const handleClose = () => {
        setItem({ ...CREATE_CATEGORY_MODEL });
        setEmptyFields(false);
        onHide();
    };
    // 🔹 Create CATEGORY
    const createCategoryBody = item.toRegister(CATEGORY_TYPE.CATEGORY, contractorId );

    // 🔹 Create SUBCATEGORY
    const createSubcategoryBody = item.toRegister(CATEGORY_TYPE.SUBCATEGORY, contractorId );

    const handleCreate = async (body) => {
        const { payload } = await dispatch(CreateCategoryAndSubcategory(body));
        const {
            data: { data, success, code },
        } = payload;

        if (success) {
            toast.success(t('has_been_created_successfully'));
            setModified(true);
        } else {
            errorMsg(code);
        }
    };

    const handleConfirm = async () => {
        if (!item.isValid()) {
            setEmptyFields(true);
            return;
        }

            if (type === CATEGORY_TYPE.CATEGORY) {
                await handleCreate(createCategoryBody);
            }

            if (type === CATEGORY_TYPE.SUBCATEGORY) {
                await handleCreate(createSubcategoryBody);
            }

            handleClose();

    };

    return (
        <CustomModal
            show={show}
            onHide={handleClose}
            onConfirm={handleConfirm}
            buttonConfirm='confirm'
            buttonCancelText='dismiss'
            size='l'
            classNameBody="pt-2"
        >
            <div className='d-flex align-items-center mb-3'>
                <div className='icons-invitation-start'>{Icon && <Icon className='w-100 h-100' />}</div>
                <p className='fs-24px ibl-font-w-600 font-color-general-950 pl-1 m-0'>{t(titleModal)}</p>
            </div>
            <CustomCard classCard='card-border-8px overflow-hidden' classContent='p-0'>
                <IconBannerCategory className='w-100 h-100 mb-3' />
                <div className='m-3'>
                    <CustomTextField
                        id='txt_cc_create_category'
                        trans={'name'}
                        name='name'
                        type='text'
                        value={item?.name}
                        onChange={handleChange}
                        required
                        emptyFields={emptyFields}
                        placeholder={inputModal}
                        length={128}
                    />
                </div>
            </CustomCard>
        </CustomModal>
    );
};

export default CreateCategory;
